// extracted by mini-css-extract-plugin
module.exports = {"bb-sidebar-highlights":"bb-sidebar-highlights__n0K_w"};